import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linear-background card",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-dark" }, " Estimator (Old — not used anymore; click on search icon to get all time numbers only if you really need it ) ", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "flex-grow-1 me-2" }
const _hoisted_12 = {
  href: "#",
  class: "fw-bolder text-gray-800 text-hover-primary fs-6"
}
const _hoisted_13 = { class: "text-muted fw-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_EstimatorFilterWidgets = _resolveComponent("EstimatorFilterWidgets")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["card", _ctx.widgetClasses])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", _hoisted_5, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen004.svg" })
                  ])
                ])
              ]),
              _createElementVNode("button", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                ])
              ]),
              _createVNode(_component_EstimatorFilterWidgets, {
                onFilterSelected: _ctx.onChanges,
                onReset: _ctx.onReset
              }, null, 8, ["onFilterSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([[
            'mb-7' && _ctx.list.length - 1 !== index,
            `bg-light-${item.color}`,
          ], "d-flex align-items-center rounded p-5 mb-7"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-${item.color}`, "svg-icon me-5"])
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(item.title), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.text), 1)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass([`text-${item.color}`, "fw-bolder py-1"])
                }, _toDisplayString(item.number), 3)
              ], 2))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}